"use client";

import { c as _c } from "react/compiler-runtime";
import { classNames } from "@opensea/ui-kit";
import { useRef } from "react";
import { ChartContainer } from "../ChartContainer";
import { CandlestickChartTooltip } from "./CandleStickChartTooltip";
import { useInitializeCandlestickChart } from "./hooks/useInitializeCandlestickChart";
import { usePrepareCandlestickChart } from "./hooks/usePrepareCandlestickChart";
import { useSubscribeCandlestickChartCrosshair } from "./hooks/useSubscribeCandlestickChartCrosshair";

// -- Component ------------------------------------------------------------------------------------
export function CandlestickChartGraph(t0) {
  const $ = _c(16);
  const {
    data,
    initialTimeRange,
    className,
    onPriceHover,
    onTimeRangeChange
  } = t0;
  const containerRef = useRef(null);
  const chart = usePrepareCandlestickChart(containerRef, Boolean(onTimeRangeChange));
  let t1;
  if ($[0] !== chart || $[1] !== data || $[2] !== initialTimeRange || $[3] !== onTimeRangeChange) {
    t1 = {
      chart,
      data,
      initialTimeRange,
      onTimeRangeChange
    };
    $[0] = chart;
    $[1] = data;
    $[2] = initialTimeRange;
    $[3] = onTimeRangeChange;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const initialized = useInitializeCandlestickChart(t1);
  let t2;
  if ($[5] !== chart || $[6] !== initialized) {
    t2 = {
      chart,
      initialized,
      containerRef
    };
    $[5] = chart;
    $[6] = initialized;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const crosshair = useSubscribeCandlestickChartCrosshair(t2);
  let t3;
  if ($[8] !== className) {
    t3 = classNames("h-[450px] w-full", className);
    $[8] = className;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== crosshair || $[11] !== onPriceHover) {
    t4 = <CandlestickChartTooltip crosshair={crosshair} onPriceHover={onPriceHover} />;
    $[10] = crosshair;
    $[11] = onPriceHover;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t3 || $[14] !== t4) {
    t5 = <ChartContainer className={t3} ref={containerRef}>{t4}</ChartContainer>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}